import React from 'react';
import classnames from 'classnames';
import { isBrowser } from 'react-device-detect';

import Arrow from 'images/icons/arrow-long.svg';

import styles from './index.css';

const Button = ({
	className,
	contentClassName,
	arrow,
	children,
	animation = true,
	reverse,
	maskColor,
	onClick = () => {},
}) => (
	<div
		className={classnames(styles.button, className, {
			[styles.reverse]: reverse,
			[styles.isBrowser]: isBrowser,
		})}
		role="button"
		tabIndex="0"
		onClick={onClick}
		onKeyPress={() => {}}
	>
		{animation && (
			<div
				className={styles.animationMask}
				style={{
					backgroundColor: maskColor || '',
				}}
			/>
		)}
		<div
			className={classnames(styles.content, contentClassName, {
				[styles.animation]: animation,
			})}
		>
			{children}
			{arrow && (
				<div className={styles.arrow}>
					<Arrow />
				</div>
			)}
		</div>
	</div>
);

export default Button;



// WEBPACK FOOTER //
// ./src/components/atoms/Button/index.js